import { Helpers } from '../../helpers';
import { IPowerSourceType } from '../../interfaces/ipower-source-type';
import { WaterWell } from '../water-well';

export class PowerSourceTypeBase {
  PowerSourceTypesId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  WaterWells_PowerSourceType?: Array<WaterWell> | null;

  constructor(item?: IPowerSourceType) {
    if (item) {

      this.PowerSourceTypesId = item.PowerSourceTypesId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.WaterWells_PowerSourceType = Helpers.createClassArray(WaterWell, item.WaterWells_PowerSourceType);
    }
  }
}